import { Button } from "@mui/material";
import React from "react";

const CustomDarkButton = ({ title, handleClick, className }) => {
  return (
    <Button
      sx={{
        backgroundColor: "transparent",
        color: "black",
        height: "40px",
        cursor: "pointer",
        border: "1px solid #d4d4d4",
        borderRadius: "8px",
        boxShadow: "none"
      }}
      variant="contained"
      onClick={handleClick}
      className={className}
    >
      {title}
    </Button>
  );
};

export default CustomDarkButton;
